module.exports = __webpack_public_path__ + "img/ico-construction-beginning-done.d47515d7.svg";